const isReferAFriendShouldBeShown = (withUpsell, isReferAFriendAvailable) => {
  if (!isReferAFriendAvailable) return false;

  return !withUpsell;
};

export default isReferAFriendShouldBeShown;
